export default class LazyObserver {
  constructor(params) {
    this.selector = params.selector;
    this.threshold = params.threshold || 0;
    this.activeClass = params.activeClass;
    this.observe = obj => params.observe(obj);

    this.componentsNodeList = document.querySelectorAll(this.selector);
    this.componentsArr = [...this.componentsNodeList];

  }
  _createObserver(){

    if ( this.componentsArr.length === 0 ) return false;

    return (new IntersectionObserver((entries, IO) => {
      entries.forEach((entry) => {
        const target = entry.target;
        if (entry.isIntersecting) {
          this.observe({ target, IO, activeClass:this.activeClass });
        }
      });
    }, { threshold: this.threshold }));
  }
  initObserver(){
    this.componentsArr.forEach((cmp) => (this._createObserver()).observe(cmp));
  }
  init(){
    this.initObserver();
  }
}
